import { dateFunc } from "@/components/Functions/dateFunc";
import { UpdatedDateCell } from "./claimTabType";
import { Link, useNavigate } from "react-router-dom";

export const CaseRenderers = () => {
  const navigate = useNavigate();
  return {
    updatedDateRenderer: function (param: UpdatedDateCell) {
      return <>{dateFunc(param.data.updatedOn).formattedDateOnly}</>;
    },
    claimCellRenderer: function (param: any) {
      return (
        <>
          {
            <span
              onClick={() => {
                navigate(`./claim/${param.data.claimId}`, {
                  state: { from: param.data.claimId },
                });
              }} 
              className="text-bold-underline"
            >
              {" "}
              {param.data.claimReferenceId}{" "}
            </span>
          }
        </>
      );
    },
    creditorCellRenderer: function (param: any) {
      return (
        <>
          {
            <Link
              to={`./creditor/${param.data.creditorId}`}
              state={{ from: param.data.creditorId }}
            >
              <span className="text-bold-underline">
                {" "}
                {param.data.creditorName}{" "}
              </span>
            </Link>
          }
        </>
      );
    },
    debtorCellRenderer: function (param: any) {
      return (
        <>
          {
            <Link
              to={`./debtor/edit/${param.data.debtorId}`}
              state={{ from: param.data.debtorId }}
            >
              <span className="text-bold-underline">
                {" "}
                {param.data.debtorName}{" "}
              </span>
            </Link>
          }
        </>
      );
    },
  };
};
